/* @flow */
import { Component } from "react";
import type { Node } from "react";

type Props = {
  children?: (screen: Screen) => Node
};

type State = {
  orientation: Object
};

class Orientation extends Component<Props, State> {
  state = {
    orientation: window.innerWidth > window.innerHeight
  };

  handleOrientationChange = () => {
    this.setState({
      orientation: window.innerWidth > window.innerHeight
    });
  };

  componentDidMount() {
    const loop = () => {
      if (this.active) {
        let { orientation } = this.state;

        if (window.innerHeight >= 320) {
          let nextOrientation = window.innerWidth > window.innerHeight;

          if (orientation !== nextOrientation) {
            this.setState({ orientation: nextOrientation });
          }
        }

        requestAnimationFrame(loop);
      }
    };
    this.active = true;
    loop();
  }

  componentWillUnmount() {
    this.active = false;
  }

  render() {
    if (typeof this.props.children !== "function") {
      return null;
    }

    return this.props.children(this.state.orientation);
  }
}

export default Orientation;

export function isLandscape(isLandscape) {
  return isLandscape;
}



// WEBPACK FOOTER //
// ./src/components/common/Orientation.js